export const pendingNotificationsCollection = 'pendingnotificationlist';
